import { Component, Input } from "@angular/core";
import { Vulnerability } from "../../interfaces/vulnerability";
import { DependencyTrackDtaService } from "../../services/dependency-track-dta/dependency-track-dta.service";
import { PoNotificationService } from "@po-ui/ng-components";

@Component({
  selector: "app-dependency-track-vulnerabilities-table-detail",
  templateUrl: "./dependency-track-vulnerabilities-table-detail.component.html",
  styleUrls: ["./dependency-track-vulnerabilities-table-detail.component.css"],
})
export class DependencyTrackVulnerabilitiesTableDetailComponent {
  @Input() vulnerability: Vulnerability;

  analysis: string = "";
  aiAnalysisLabel: string = "✨ Análise com IA";
  analysing: boolean = false;

  constructor(
    private poNotificationService: PoNotificationService,
    private dependencyTrackDtaService: DependencyTrackDtaService
  ) {}

  aiAnalysis(vulnerability: Vulnerability): void {
    this.analysing = true;

    this.dependencyTrackDtaService
      .postDtaChat({ content: JSON.stringify(vulnerability.finding) })
      .subscribe({
        next: ({ content }) => {
          this.analysis = content;
        },
        complete: () => {
          this.analysing = false;
          this.aiAnalysisLabel = "";
        },
        error: () => {
          this.analysing = false;

          this.poNotificationService.error(
            "Falha ao realizar análise com IA! Tente novamente mais tarde."
          );
        },
      });
  }
}
